// @flow
import VendorView from "./VendorView";

export default VendorView;
